module.exports = {"TXTCLI_Blinds":{"id":"TXTCLI_Blinds","defaultMessage":"Blindy"},"TXTCLI_Level":{"id":"TXTCLI_Level","defaultMessage":"Úroveň"}}